import { z } from 'zod';
import { EnumSchema, FromSchema } from '@40seas/entities/common';

export enum HeronReportCreditScoreStatus {
    NotAvailable = 'not_available',
    PartiallyAvailable = 'partially_available',
    Available = 'available',
}

export const HeronReportCreditScoreSchema = z
    .object({
        dataQualityIssues: z.array(z.string()).optional().nullish(),
        value: z.number().nullish().optional(),
        status: EnumSchema(HeronReportCreditScoreStatus),
    })
    .strict();

export class HeronReportCreditScore extends FromSchema(HeronReportCreditScoreSchema) {
    dataQualityIssues?: string[];
    value?: number;
    status: HeronReportCreditScoreStatus;
}
